import { Autocomplete, Chip, createFilterOptions, TextField } from '@mui/material';
import type { IAutocompleteProps } from '../../../types';

/**
 * Renders an input field to handle multiple options selections
 * @param {IAutocompleteProps} props AutoComplete Props
 * @returns {React.JSX.Element} JSX element
 */
export const MultiAutocompleteInput = (props: IAutocompleteProps) => {
  const handleInputChange = (newVal) => {
    const val =
      newVal?.length > 0
        ? JSON.stringify(newVal.map((x) => (x.code === 'NA' ? x.name : x.code)))
        : null;
    props.handleChange(props.code, val);
  };
  const hasInvalidValue =
    Array.isArray(props.value) && props.value.some((item) => item.code === 'NA');

  return (
    <Autocomplete
      multiple
      id={props.code + '-multi-autocomplete'}
      data-testid="multi-autocomplete"
      size={props.size}
      options={props.data}
      onChange={(_, newVal) => handleInputChange(newVal)}
      getOptionLabel={(option) => option.name}
      filterSelectedOptions
      disabled={props.disabled}
      value={props.value ? props.value : []}
      className={hasInvalidValue ? 'autocomplete-value-mismatch' : undefined}
      renderInput={(params) => (
        <TextField {...params} label={props.label} error={!!hasInvalidValue} />
      )}
      filterOptions={createFilterOptions({ trim: true })} // Create a custom filter that trims whitespace
      renderValue={(value, getTagProps) =>
        value.map((option, index: number) => (
          <Chip
            variant="outlined"
            label={option.name}
            {...(getTagProps ? getTagProps({ index }) : {})}
            key={option.code}
            color={option.code === 'NA' ? 'error' : 'default'}
          />
        ))
      }
    />
  );
};
